import { LANDING } from '../actions/types';

export default (state = { isSignedIn: false }, action) => {
  switch (action.type) {
    case LANDING:
      return {
        ...state,
        isSignedIn: action.payload,
      };
    default:
      return state;
  }
};
